import { MarketplaceStoreEditionType } from '@atlassian/mpac-types/graphql-gateway-types';
const {
  Standard,
  Advanced,
  Free
} = MarketplaceStoreEditionType;
export const HIDE_NEW_LOZENGE_AFTER_DAYS = 30;
export const DEFAULT_SELECTED_PLAN = Advanced;
export const DEFAULT_SELECTED_PLAN_NO_ADVANCED = Standard;
export const EDITIONS = {
  TITLE: 'Editions',
  LABEL: 'Edition',
  EXPLORE_LINK_TEXT: 'Explore app editions',
  DESCRIPTION: 'This app offers two different editions - Standard and Advanced. You can start a free trial of either edition, and change your edition anytime during or after the trial.',
  DESCRIPTION_WITH_FREE: 'This app offers three editions - Free, Standard and Advanced. You can start a free trial of either edition, and change your edition anytime during or after the trial.',
  DESCRIPTION_WITHOUT_ADVANCED: 'This app offers two editions - Free and Standard. You can start a free trial of either edition, and change your edition anytime during or after the trial.'
};
export const EDITIONS_TYPE = {
  [Free]: 'Free',
  [Standard]: 'Standard',
  [Advanced]: 'Advanced'
};

// For Standard/Advanced only

export const FEATURES_TITLE = {
  [Free]: 'Includes:',
  [Standard]: 'Everything from Free, plus:',
  [Advanced]: 'Everything from Standard, plus:'
};
export const EDITIONS_SUBTITLE_PARTNERS = {
  [Standard]: 'Edition for teams that want to scale fast',
  [Advanced]: 'Edition for large and enterprise teams'
};
export const EDITIONS_SUBTITLE_CUSTOMERS = {
  [Standard]: 'Onboard your team and scale fast',
  [Advanced]: 'Unlock the full range of app features'
};
export const EDITIONS_SUBTITLE_CUSTOMERS_WITH_EXPERIMENT = {
  [Standard]: 'Get started fast with essential features',
  [Advanced]: 'Unlock all features for growing teams'
};
export const ADVANCED_EDITION_BANNER_TEXT = 'SCALE WITH CONFIDENCE';
export const ADVANCED_EDITION_RIBBON_TEXT = 'TRUSTED BY GROWING ORGANIZATIONS';

// For Free/Standard/Advanced

export const FEATURES_TITLE_FOR_FREE_EDITION_VIEW = {
  [Free]: 'Includes:',
  [Standard]: 'Everything from Free plus:',
  [Advanced]: 'Everything from Standard plus:'
};
export const EDITIONS_SUBTITLE_CUSTOMERS_FOR_FREE_EDITION_VIEW = {
  [Free]: 'Free for all users',
  [Standard]: 'Onboard teams, scale fast',
  [Advanced]: 'Unlock all app features'
};
export const EDITIONS_SUBTITLE_CUSTOMERS_FOR_FREE_EDITION_VIEW_WITH_EXPERIMENT = {
  [Free]: 'Free for all users',
  [Standard]: 'Get started fast with essential features',
  [Advanced]: 'Unlock all app features for growing teams'
};
export const EDITIONS_SUBTITLE_PARTNERS_FOR_FREE_EDITION_VIEW = {
  [Free]: 'Free for all users',
  [Standard]: 'Edition for teams that want to scale fast',
  [Advanced]: 'Edition for large and enterprise teams'
};
export const TEST_IDS = {
  EDITION_CARD_TITLE: 'edition-card-title',
  FEATURE_LABEL: 'features-label',
  ACCORDION_LIST_ITEM: 'accordion-list-item',
  ACCORDION_PRICING: 'accordion-pricing',
  ACCORDION_PRICING_PER_UNIT: 'accordion-pricing-per-unit',
  START_FREE_TRIAL_BUTTON: 'start-free-trial-button',
  MORE_FEATURES_LINK: 'more-features-link',
  MORE_FEATURES_BUTTON: 'more-features-btn',
  FEATURE_COMPARISON_TITLE: 'feature-comparison-title',
  FEATURE_COMPARISON_TABLE: 'feature-comparison-table',
  FEATURE_COMPARISON_DESKTOP_VIEW: 'feature-comparison-desktop-view',
  FEATURE_COMPARISON_MOBILE_VIEW: 'feature-comparison-mobile-view'
};